
import { Component, Vue } from "vue-property-decorator";
import axios from "axios";
@Component({})
export default class ProductosLocales extends Vue {
  private win = window;
  private base = window.location;
  private left = false;

  private ProductosGo(nombreWeb: any) {
    if (
      this.$router.currentRoute.name == "DetallesProductos" &&
      this.$router.currentRoute.params.nombre == nombreWeb
    ) {
      this.$router.go(0);
    } else {
      this.$router
        .push({
          name: "DetallesProductos",
          params: { nombre: nombreWeb }
        })
        .catch(err => {
          console.log(err);
        });
    }
  }

  private routerGo(name: string) {
    if (name && name != "") {
      if (this.$router.currentRoute.name == name) {
        this.$router.go(0);
      } else {
        this.$router.push({ name: name }).catch(err => {
          console.log(err);
        });
      }
    }
  }
}
